












import vue from "vue";
import { VUEX_EXERCISE_ACTION_NAMES, VUEX_EXERCISE_NAMESPACE } from "@tt-app/constants";

const { HINTS_DISPLAY_TOGGLE } = VUEX_EXERCISE_ACTION_NAMES;

interface Computed {
  hints: string[];
}

export default vue.extend<any, any, Computed, any>({
  name: "HintsSetting",

  methods: {
    handleToggleClick() {
      this.$store.dispatch(`${VUEX_EXERCISE_NAMESPACE}/${HINTS_DISPLAY_TOGGLE}`);
    }
  },

  computed: {
    hints() {
      return this.$store.state.exercise.settings.hints;
    }
  }
});
